export default () => {
	$('.tvshow .list .time').each((i, el) => {
		const realTime = $(el).attr('data-realtime')

		const cDate = new Date()
		cDate.setMilliseconds(0)
		cDate.setSeconds(0)

		const pDate = new Date(
			`${cDate.getFullYear()}-
                         ${cDate.getMonth() + 1}-
                         ${cDate.getDate()} ${realTime}`
		) // getMonth + 1 = счет месяцев идет с 0

		const cValueDate = cDate.valueOf()
		const pValueDate = pDate.valueOf()

		if (pValueDate > cValueDate) {
			$(el).trigger('click')
			$(el).parent('li').prev().children('.active').html('в эфире')
			$(el).parent('li').prev().addClass('active')
			return false
		}
	})
}
